import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'users', redirectTo: 'users/list', pathMatch: 'full' },
  {
    path: 'users',
    children: [
      {
        path: 'list',
        loadComponent: () => import('./list/users-list.component').then((m) => m.UsersListComponent),
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./details/users-details.component').then((m) => m.UsersDetailsComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class usersRoutingModule {
  static routes = admin;
}
